/* eslint-disable @sailor/react-component-filename */
/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable @sailor/base-no-dynamic-import */
import { lazy } from 'react'

export default [
  {
    path: '/',
    label: '首页',
    component: lazy(() => import('@/pages/home')),
  },
  {
    path: '/enterprise',
    label: '企业管理',
    component: lazy(() => import('@/pages/enterprise')),
  },
  {
    path: '/staff/batchUpdate',
    label: '员工批量更新',
    component: lazy(() => import('@/pages/staff/pages/batchUpdate')),
  },
  {
    path: '/batch',
    label: '批次管理',
    component: lazy(() => import('@/pages/batch')),
  },
  {
    path: '/rule', //
    label: '规则管理',
    component: lazy(() => import('@/pages/rule')),
  },
  {
    path: '/order', //
    label: '订单查询',
    component: lazy(() => import('@/pages/order')),
  },
  {
    path: '/rule/detail', //
    label: '规则详情',
    component: lazy(() => import('@/pages/rule/pages/detail/index')),
  },
  {
    path: '/rule/balance', //
    label: '余额管理',
    component: lazy(() => import('@/pages/balance')),
  },
  {
    path: '/bill', //
    label: '财务管理',
    component: lazy(() => import('@/pages/bill')),
  },
  {
    path: '/login', //
    label: '登录',
    component: lazy(() => import('@/pages/login')),
  },
  {
    path: '/password/forget', //
    label: '忘记密码',
    component: lazy(() => import('@/pages/password/Forget')),
  },
  {
    path: '/password/reset', //
    label: '修改密码',
    component: lazy(() => import('@/pages/password/Reset')),
  },

]
